module.exports = __webpack_public_path__ + "84f05fab10f7b008096b0b6e7ae0193c.svg";